module.exports = __webpack_public_path__ + "img/pdf.eaf2093c.svg";